export default class SubscriberShowCtrl {
    constructor($scope, $filter, $stateParams, $state, SideMenu, Subscriber, Events, SweetAlert) {
        SideMenu.setActive('subscriber');

        this._scope = $scope;
        this._state = $state;
        this._stateParams = $stateParams;
        this._translator = $filter;

        this.subscriberRepo = Subscriber;
        this.eventHandler = Events;
        this.alerter = SweetAlert;

        this.status = this._stateParams.subFolder ? this._stateParams.subFolder : 'information';
        this.subscriberRepo.find(this._stateParams.id).then((response) => {
            this.subscriber = response.data;
        });

        this._scope.$on('subscriber:add:suppression', (event, data) => {
            this.subscriberRepo.suppress(data.subscriberId, data.suppression).then(() => {
                this._state.go(this._state.current, {}, { reload: true });
                this.eventHandler.flashEvent('notification', this._translator('translate')('SUBSCRIBER_MODAL:UNSUBSCRIBE:SUPPRESSED'));
            }, () => {
                this.alerter.swal(this._translator('translate')('SUBSCRIBER_MODAL:UNSUBSCRIBE:SUPPRESSED_FAILED'), "", "error");
            })
        });

        this._scope.$on('account:changed', () => {
            this._state.go('subscriber.index');
        });
    }


    setStatus(status) {
        if (this._stateParams.folder) {
            this._state.go('subscriber.folder.show.subFolder', { folder: this._stateParams.folder, subFolder: status });
        } else {
            this._state.go('subscriber.show.subFolder', { subFolder: status });
            this.status = status;
        }
    };

    resubscribe() {
        this.subscriberRepo.resubscribe(this._stateParams.id).then(() => {
            this.subscriber.suppressions.data = [];
            this.subscriber.has_suppressions = false;
            this.eventHandler.flashEvent('notification', this._translator('translate')('SUBSCRIBER_MODAL:RESUBSCRIBED'));
        });
    };

    suppressSubscriber() {
        this._scope.$broadcast('subscriber:show:suppression', this.subscriber);
    }

    deleteSubscriber() {
        this.alerter.swal({
                title: this._translator('translate')('SUBSCRIBER_MODAL:DELETE:TITLE'),
                text: this._translator('translate')('SUBSCRIBER_MODAL:DELETE:EXPLANATION'),
                type: "warning",
                customClass: 'sweet-alert--delete',
                showCancelButton: true,
                confirmButtonText: this._translator('translate')('GLOBAL:YES'),
                cancelButtonText: this._translator('translate')('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.subscriberRepo.delete(this.subscriber.id).then(() => {
                        this._state.go('subscriber.index');
                        this._scope.$emit('subscriber:deleted');
                        this.eventHandler.flashEvent('notification', this._translator('translate')('SUBSCRIBER_MODAL:DELETE:DELETED'));
                    }, () => {
                        this.alerter.swal(this._translator('translate')('SUBSCRIBER_MODAL:DELETE:DELETE_FAILED'), "", "error");
                    })
                }
            }
        )
    }
}
